import React from "react";
import { Route, Routes } from "react-router-dom";
import { _routes } from "Benchmarking/Routes/routes";
import "Benchmarking/Scss/Content.scss";

const Content = () => {
  return (
    <div className="content-benchmarking">
      <Routes>
        {_routes.map((route, index) => {
          return (
            <Route
              path={route.path}
              exact
              element={<route.component />}
              key={index}
            />
          );
        })}
      </Routes>
    </div>
  );
};

export default Content;
